<template>
  <div class="h-full max-h-full">
    <div class="h-full flex flex-col relative" v-if="showDirections">
      <div class="back-outer-wrapper">
        <div class="back-wrapper">
          <div @click="backFromDirections()" class="group-back-button flex flex-row">
            <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.366211 8.61719C-0.12207 9.10547 -0.12207 9.89844 0.366211 10.3867L7.86621 17.8867C8.35449 18.375 9.14746 18.375 9.63574 17.8867C10.124 17.3984 10.124 16.6055 9.63574 16.1172L3.01855 9.5L9.63184 2.88281C10.1201 2.39453 10.1201 1.60156 9.63184 1.11328C9.14355 0.625 8.35059 0.625 7.86231 1.11328L0.362305 8.61328L0.366211 8.61719Z" fill="#0F417C"/>
            </svg>
            <WFTranslate k="back">Back</WFTranslate>
          </div>
        </div>
      </div>
      <div v-if="steps.length > 0" class="flex-1 overflow-y-auto overflow-x-hidden">
        <div class="h-full max-h-full">
          <div class="flex flex-row content-center items-center accessible-wrapper mt-[20]">
            <div>
              <div @click="setAccessible(!accessible)">
                <svg style="display: inline-block;" v-if="accessible === true" width="44" height="24" viewBox="0 0 44 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="44" height="24" rx="12" fill="#0F417C"/>
                  <circle cx="32" cy="12" r="11.5" fill="white" stroke="#0F417C"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.96924 16.0308L9.97016 16.0317C10.1164 16.1765 10.3082 16.25 10.5 16.25C10.6918 16.25 10.8836 16.1765 11.0299 16.0317L18.0313 9.03034C18.3233 8.73682 18.3233 8.26322 18.0313 7.96969L18.0303 7.96879C17.7368 7.67676 17.2628 7.67723 16.9692 7.96925L10.5 14.4394L7.03035 10.9688C6.73682 10.6768 6.26322 10.6768 5.9697 10.9688L5.9688 10.9697C5.67677 11.2632 5.67722 11.7373 5.96925 12.0308L9.96924 16.0308Z" fill="white"/>
                </svg>

                <svg style="display: inline-block;" v-if="accessible === false" width="44" height="24" viewBox="0 0 44 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="44" height="24" rx="12" fill="#98A2B3"/>
                  <circle cx="12" cy="12" r="11.5" fill="white" stroke="#98A2B3"/>
                </svg>

                <WFTranslate k="accessible">Accessible</WFTranslate>
              </div>

            </div>
          </div>

          <div class="directions-display">
            <div class="your-location">"<WFTranslate k="your-location">Your location</WFTranslate>"</div>
            <div v-for="step in steps" v-bind:key="step.id" class="step-item py-16">
              <div class="flex flex-row content-center items-center accessible-wrapper">
                <div class="step-icon-wrapper w-[75px]"><NavigationIcon :icon="step.icon" /></div>
                <div>
                  <div class="step-title">{{step.title}}</div>
                  <div class="step-duration">{{step.duration}}</div>
                </div>
              </div>
            </div>
            <div class="destination">
              <svg style="display: inline-block;" width="13" height="17" viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.30234 16.575C9.03906 14.4434 13 9.27695 13 6.375C13 2.85547 10.0885 0 6.5 0C2.91146 0 0 2.85547 0 6.375C0 9.27695 3.96094 14.4434 5.69766 16.575C6.11406 17.083 6.88594 17.083 7.30234 16.575ZM6.5 4.25C7.07464 4.25 7.62574 4.47388 8.03207 4.8724C8.43839 5.27091 8.66667 5.81141 8.66667 6.375C8.66667 6.93859 8.43839 7.47909 8.03207 7.8776C7.62574 8.27612 7.07464 8.5 6.5 8.5C5.92536 8.5 5.37426 8.27612 4.96794 7.8776C4.56161 7.47909 4.33333 6.93859 4.33333 6.375C4.33333 5.81141 4.56161 5.27091 4.96794 4.8724C5.37426 4.47388 5.92536 4.25 6.5 4.25Z" fill="#98A2B3"/>
              </svg>

              {{ currentPOI.getName(language) }}
            </div>
          </div>
        </div>

      </div>
      <div v-if="noPath" class="location-inaccessible p-8 mt-24 text-center font-bold">
        <WFTranslate k="location-inaccessible">Location inaccessible from this point</WFTranslate>
      </div>

      <div class="directions-qr-wrapper qr-wrapper flex flex-row justify-end" v-if="!mobile && qr">
        <div class="flex-1"></div>
        <div>
          <div class="flex flex-row">
            <div class="flex-1 pr-[4pt] align-label-end">
              <WFTranslate k="scan-qr-to-open-in-mobile">Scan QR code to open in mobile</WFTranslate>
            </div>
            <div class="img-wrapper">
              <img :src="qr" />
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="h-full flex flex-col relative" v-if="!showDirections">
      <div class="back-outer-wrapper">
        <div class="back-wrapper">

          <div @click="backFromPOI()" class="group-back-button flex flex-row">
            <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.366211 8.61719C-0.12207 9.10547 -0.12207 9.89844 0.366211 10.3867L7.86621 17.8867C8.35449 18.375 9.14746 18.375 9.63574 17.8867C10.124 17.3984 10.124 16.6055 9.63574 16.1172L3.01855 9.5L9.63184 2.88281C10.1201 2.39453 10.1201 1.60156 9.63184 1.11328C9.14355 0.625 8.35059 0.625 7.86231 1.11328L0.362305 8.61328L0.366211 8.61719Z" fill="#0F417C"/>
            </svg>
            <WFTranslate k="back">Back</WFTranslate>
          </div>
        </div>
      </div>

      <div class="flex-1 overflow-y-auto overflow-x-hidden">
        <div class="poi-header-wrapper" :style="getPOIBackgroundStyles()">
          <div class="flex flex-row justify-between">
            <div>
              <div class="qr-wrapper flex flex-row" v-if="qr">
                <div class="img-wrapper">
                  <img :src="qr" />
                </div>
                <div class="flex-1">
                  <WFTranslate k="scan-qr-to-open-in-mobile">Scan QR code to open in mobile</WFTranslate>
                </div>

              </div>
            </div>
            <div style="text-align: right; align-content: center;">
              <img :src="currentPOI.getIconUrl() ?? currentPOI.getIconUrl()" v-if="!currentPOI.background_id" class="max-h-66 poi-icon" />
            </div>
          </div>


        </div>

        <div class="poi-title-wrapper">
          <div class="flex justify-between items-center">
            <div class="poi-title">{{ currentPOI.getName(language) }}</div>
            <div v-if="currentPOI.getFloor()" class="justify-self-end level-title">
              {{currentPOI.getFloor().getName(language)}}
            </div>
          </div>
        </div>

        <div class="poi-description-wrapper mt-20">
          <div class="flex justify-between items-center mb-20">
            <div class="justify-self-end">
              <div class="route-btn" @click="openDirections()">
                <div class="flex justify-between items-center">
                  <WFTranslate k="route">Route</WFTranslate>
                  <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.63281 9.88379C10.1211 9.39551 10.1211 8.60254 9.63281 8.11426L2.13281 0.614259C1.64453 0.125977 0.851561 0.125977 0.36328 0.614259C-0.125001 1.10254 -0.125001 1.89551 0.36328 2.38379L6.98047 9.00098L0.367187 15.6182C-0.121094 16.1064 -0.121094 16.8994 0.367187 17.3877C0.855469 17.876 1.64844 17.876 2.13672 17.3877L9.63672 9.8877L9.63281 9.88379Z" fill="#ffffff"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="poi-description-value" v-if="!!currentPOI.getDescription(language)" v-html="currentPOI.getDescription(language)"></div>
          <WFPOIAdvertisements class="mt-14 single-poi-offers" v-if="hasAdvertisements" :ads="currentPOI.getAdvertisements()"></WFPOIAdvertisements>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex';
import { WFTranslate } from '@3dwayfinder/wayfinder-vue-components'
//import {metersToMinutes} from "@/helpers/navigation";
import NavigationIcon from "@/components/NavigationIcon";
import QRCode from 'qrcode'

export default {
    components: {
      WFTranslate,
      NavigationIcon,
    },
    computed: {
		...mapState('wf', ['language', 'mobile', 'poiAdvertisements']),
      accessible() {
        return this.$store.state.accessible;
      },
	},
  data() {
    return {
      showDirections: false,
      qr: null,
      steps: [],
      noPath: false
    }
  },
  props: {
    currentPOI: {
      default: null,
      type: Object
    },
    setCurrentPOI: {
      default: null,
    },
      defaultDirectons: {
      default: false,
    },
  },
  mounted () {
    QRCode.toDataURL(`https://vnomap.ltou.lt/projects/main/VilniusAirport/?kiosk=${this.$wayfinder.getKiosk()}&destination-poi=poi-${this.currentPOI.id}&upscale=2`)
        .then(url => {
          this.qr = url;
        })
        .catch(err => {
          console.error(err)
        });
    if (this.defaultDirectons) {
      this.openDirections();
    }
  },
    methods: {
      setAccessible(bool) {
        this.$store.dispatch('setAccessible', bool);
        this.onPOIClick(this.currentPOI);
      },
      openDirections() {
        this.showDirections = true;
        this.getSteps();
        this.onPOIClick(this.currentPOI);
        this.$emit('directionsOpened', this.currentPOI);
        this.$store.dispatch('setDirectionsOpened', true);
      },
      getNavigationIgnoreTypes({room_id}) {
        let ignoreTypes = this.accessible ? ["escalator", "stairs"] : [];

        if (room_id) {
          if (room_id.slice(0, 6) == 'gate-a') {
            ignoreTypes.push('gate-b');
          } else if (room_id.slice(0, 6) == 'gate-b') {
            ignoreTypes.push('gate-a');
          }

        }
        return ignoreTypes;
      },
      backFromDirections() {
        this.showDirections = false;
        this.$store.dispatch('setDirectionsOpened', false);
      },
      backFromPOI () {
        console.log('backFromPOI');
        this.$store.dispatch('setPOI',  null);
      },
      onPOIClick(poi) {
        this.$wayfinder.showPath(poi.getNode(), poi, {"ignoreTypes": this.getNavigationIgnoreTypes(poi)});
      },
      getNavigationTurnTranslation(turn) {
        return this.$wayfinder.translator.get(`turn-${turn}`);
      },
      getPOIBackgroundStyles() {
        if (!this.currentPOI.background_id) {
          return {};
        }
        return {
          background: `url(${this.currentPOI.getBackgroundUrl()}) no-repeat center center`,
          backgroundSize: 'cover',
          height: '35rem',
        };
      },
      getSteps() {
        this.noPath = false;
        this.$wayfinder.showFloor(this.currentPOI.getFloor());
        this.$wayfinder.clearHighlights()
        this.$wayfinder.setHighlights([this.currentPOI]);


        let path = this.$wayfinder.findPath(this.$wayfinder.getKioskNode(), this.currentPOI.getNode(), {"ignoreTypes": this.getNavigationIgnoreTypes(this.currentPOI)});
        if (path.length == 0) {
          this.noPath = true;
        }
        const { steps } = this.$wayfinder.pathToText(path);

        if (path.length > 0 && steps.length === 0) {
          //steps[0] = {"walk": 0, "type": "walk"};
        }

        console.log('path', path, steps)

        let result = [];

        let walkGroups = [];
        let lastWalkGroup = [];
        console.log('steps', steps);
        for (let i = 0; i < steps.length; i ++) {
          const step = steps[i];
          if ('walk' in step) {
            if (lastWalkGroup.length == 0) {
              lastWalkGroup.push(step);
            } else {
              walkGroups.push(lastWalkGroup);
              lastWalkGroup = [];
              lastWalkGroup.push(step);
            }
          } else {
            lastWalkGroup.push(step);
          }
        }

        if (lastWalkGroup.length > 0) {
          walkGroups.push(lastWalkGroup);
        }

        let loop = 0;
        for (const groupSteps of walkGroups) {

          const meters = Math.floor(groupSteps[0].walk);
          const directionStep = groupSteps[1];

          loop ++;

          // Short, straight paths contain only a walk step and no following
          // turn/use instruction.
          if (!directionStep) {
            result.push({
              id: loop,
              icon: 'walk',
              title: this.$wayfinder.translator.get('path-walk', [meters]),
              duration: null
            });
            continue;
          }

          const direction = directionStep.turn ?? directionStep.use;
          result.push({
            id: loop,
            icon: direction,
            title: this.getNavigationTurnTranslation(direction),
            duration: `${meters}m`
          });

          if (groupSteps.length == 3) {
            if ('use' in groupSteps[2]) {
              loop ++;
              result.push({
                id: loop,
                icon: groupSteps[2].use,
                title: this.$wayfinder.translator.get('use-' + groupSteps[2].use),
                duration: null
              });
            }
          }
          if (groupSteps.length == 4) {
            if ('go_to_floor' in groupSteps[2] && 'use' in groupSteps[3]) {
              loop ++;
              result.push({
                id: loop,
                icon: groupSteps[3].use,
                title: this.$wayfinder.translator.get('use-' + groupSteps[3].use),
                duration: `${this.$wayfinder.translator.get('go-to-floor')} ${groupSteps[2].endNode?.floor?.getName(this.language)}`
              });
            }
          }
        }
        this.steps = result;
      },
      timeToDestination() {

        let path = this.$wayfinder.findPath(this.$wayfinder.getKioskNode(), this.currentPOI.getNode(), this.accessible ? {"ignoreTypes": ["escalator", "stairs"]} : {});

        const {distance} = this.$wayfinder.pathToText(path);

        return `${distance}m`;

        //return `${metersToMinutes(distance)} min`;
      },
      hasAdvertisements () {
        if (this.currentPOI && typeof this.currentPOI.getAdvertisements() == "object"  && this.currentPOI.getAdvertisements().length > 0) {
          return true;
        }

        return false;
      }
	},
  watch: {
      currentPOI: {
        handler () {
          console.log('watch currentPOI')
          //this.getSteps();
        },
        //deep: true
      },
      language: function() {
        if (this.showDirections) {
          this.openDirections();
        }
      },
  }
}
</script>


<style lang="postcss">

.accessible-layout-wrapper {
  .single-poi-offers {
    display: none !important;
  }
}
.directions-qr-wrapper {

    border-radius: 1.6rem;
    font-size: 1.6rem;
    padding-right: 2rem;
    height: 10rem;
    width: 35rem;
    position: absolute;
    bottom: 0pt;
    right: 5pt;

  .align-label-end {
    label {
      align-content: end !important;
    }
  }

  .img-wrapper {
    img {
      border: 0.8rem solid #0F417C;
      border-radius: 1.2rem;
      height: 10rem;
      width: 10rem;
    }
  }

    label {
      display: block;
      height: 100%;
      align-content: center;
      padding-left: 1.5rem;
    }
}
  .location-inaccessible {
    color: #b10202;
    font-size: 16px;
  }
  .subgroup {
    padding: 16px 0;
    border-bottom: 1px solid rgba(156, 158, 187, 1);
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
  }
  .back-wrapper {
    display: inline-block;
  }
  .group-back-button {
    border-radius: 24px;
    padding: 6px 12px;
    border: 1px solid #0F417C;
    font-size: 16px;

    svg {
      margin-right: 10px;
    }
  }
  .back-outer-wrapper {
    border-bottom: 1px solid rgba(156, 158, 187, 1);
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .poi-floor-name {
    font-weight: 500;
    font-size: 1.6rem;
  }
  .poi-header-wrapper {
    background: #F1F4FA;
    padding: 2rem;
    border-radius: 1.6rem;
    min-height: 10rem;
    position: relative;

    .qr-wrapper {
      border-radius: 1.6rem;
      background: #fff;
      font-size: 1.6rem;
      padding-right: 2rem;
      height: 10rem;
      width: 35rem;

      .img-wrapper {
        img {
          border: 0.8rem solid #0F417C;
          border-radius: 1.2rem;
          height: 10rem;
          width: 10rem;
        }
      }

      label {
        display: block;
        height: 100%;
        align-content: center;
        padding-left: 1.5rem;
      }
    }

  }
  .poi-title-wrapper {
    border-bottom: 1px solid #9C9EBB;
    padding-bottom: 1rem;
    margin-top: 2rem;

    .poi-title {
      font-size: 2.4rem;
      font-weight: 600;
    }

    .level-title {
      font-weight: 500;
      font-size: 1.6rem;
    }
  }
  .time-to-destination-wrapper {
    font-size: 1.6rem;
    font-weight: 500;
  }
  .route-btn {
    background: #0F417C;
    color: #fff;
    display: inline-block;
    padding: 1rem 2rem;
    border-radius: 2.4rem;
    font-size: 1.6rem;
    font-weight: 600;

    svg {
      margin-left: 1rem;
    }
  }
  .poi-description-value {
    font-size: 1.8rem;
    font-weight: 500;
  }

  .accessible-wrapper {
    font-size: 1.6rem;

    label {
      margin-left: 1rem;
    }

    .radio-toggle {
      display: inline-block;
      background: #98A2B3;
      height: 2.6rem;
      border-radius: 3.2rem;
      width: 4.4rem;
      position: relative;
      margin-bottom: -0.6rem;
      margin-right: 0.6rem;

      &:after {
        position: absolute;
        display: inline-block;
        content: "";
        width: 2.4rem;
        height: 2.4rem;
        top: 1px;
        left: 1px;
        background: #fff;
        border-radius: 50%;
      }

      &.active {
        background: #0F417C;

        &:after {
          left: auto;
          right: 1px;
        }

      }
    }
  }

  .wf-poi-advertisement {
    margin-top: 1.4rem;
    border-radius: 1.8rem;
    overflow: hidden;
  }

  .directions-display {
    position: relative;
    padding-top: 4rem;
    padding-bottom: 4rem;
    margin-bottom: 4rem;
    margin-top: 2rem;
    margin-left: 10px;
    margin-right: 10px;
    border-left: 1px dashed #98A2B3;

      .your-location {
        position: absolute;
        top: -0.5rem;
        left: 2rem;
        font-size: 1.6rem;
        font-weight: 600;

        &:before {
          content: "";
          border: 1px solid #98A2B3;
          background: #fff;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          position: absolute;
          left: -2.8rem;
          top: 0.5rem;
         }
      }

    .destination {
      position: absolute;
      bottom: -0.5rem;
      left: -0.7rem;
      font-size: 1.6rem;
      font-weight: 600;

      svg {
        margin-right: 1rem;
      }
    }

    .step-item {
      border-bottom: 1px solid #9C9EBB;
      padding-left: 1.5rem;

      .step-icon-wrapper {
        padding-left: 1rem;
      }
    }
  }


</style>
